import { createContext } from 'react';

export type TipoRelatorio = 'ICMS' | 'PIS/COFINS' | 'IPI' | 'EVENTO' | 'IBS/CBS' | 'OUTROS';
export type TipoOperacao = 'Todos' | 'Entrada' | 'Saída';
export type TipoDocumento = 'Todos' | 'NFE' | 'SAT' | 'NFC';

export type FiltrosRelatorio = {
  tipoRelatorio: TipoRelatorio;
  operacao: TipoOperacao;
  documento: TipoDocumento;
  busca: string;
};

export type StatusItem = 'Processado(Sem dados)' | 'Disponível';

export type ItemRelatorio = {
  id: string;
  cnpj: string;
  status: StatusItem;
  dataProcessamento: string;
  horaProcessamento: string;
  idProcessamento: string;
  PDFRelatorio?: string;
};

export type Relatorio = {
  id: string;
  numero: string;
  nome: string;
  tipo: string;
  entradaSaida: string;
  documento: string;
  descricao: string;
  status: string;
  itens: ItemRelatorio[];
};

export type SolicitacaoHistorico = {
  ID: number;
  Tipo: string;
  Caminho_Relatorio: string;
  CNPJ_Gestor: string;
  DataHoraCriacao: string;
  UsuarioSolicitacao: string;
};

export type FiltrosHeaderSnapshot = {
  empresaId: string | null;
  empresaCnpjs: string | null;
  dataInicio: string | null;
  dataFim: string | null;
  periodoModo: 'mesano' | 'periodo';
  periodoMes: string | null;
  periodoAno: number | null;
};

export type RelatoriosContextValue = {
  filtros: FiltrosRelatorio;
  setFiltros: (filtros: Partial<FiltrosRelatorio>) => void;
  relatorios: Relatorio[];
  isLoading: boolean;
  paginaAtual: number;
  setPaginaAtual: (pagina: number) => void;
  itensPorPagina: number;
  setItensPorPagina: (itens: number) => void;
  filtrosHeaderAplicados: FiltrosHeaderSnapshot;
  cnpjsSelecionados: string[];
  empresaSelecionadaNoHeader: string | null;
  cnpjsSelecionadosNoHeader: string[];
  hasEmpresaSelecionada: boolean;
  hasEmpresaSelecionadaNoHeader: boolean;
  handleBuscar: () => void;
  handleLimparFiltrosGlobais: () => void;
};

export const RelatoriosContext = createContext<RelatoriosContextValue | null>(null);
